import { DashboardFilterValues } from './types';

// Query keys for the Dashboard V2 React Query hooks. Scoped under the
// `'dashboard_v2'` root so a single
// `queryClient.invalidateQueries({ queryKey: ['dashboard_v2'] })` flushes
// every dashboard query. Sub-keys follow `[root, resource, ...inputs]` so
// changing any input rotates the cache slot.

const ROOT = 'dashboard_v2' as const;

export const dashboardV2QueryKeys = {
  root: [ROOT] as const,
  calendarWeek: (
    agencyId: number,
    startDate: string,
    timeZone: string,
    filters: DashboardFilterValues,
  ) => [ROOT, 'calendar_week', agencyId, startDate, timeZone, filters] as const,
  summary: (agencyId: number) => [ROOT, 'summary', agencyId] as const,
  filters: (agencyId: number) => [ROOT, 'filters', agencyId] as const,
  noShow: (agencyId: number) => [ROOT, 'no_show', agencyId] as const,
  missingTimesheet: (agencyId: number) =>
    [ROOT, 'missing_timesheet', agencyId] as const,
  needsApproval: (agencyId: number) =>
    [ROOT, 'needs_approval', agencyId] as const,
  shiftDetail: (agencyId: number, shiftId: number) =>
    [ROOT, 'shift_detail', agencyId, shiftId] as const,
};
